export { default as LoginForm } from './LoginForm';



// WEBPACK FOOTER //
// ./src/paginas/Login/componentes/index.ts